import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MergeOutlinedIcon from '@mui/icons-material/MergeOutlined';
import UndoIcon from '@mui/icons-material/Undo';

import { EditPosOrderType } from 'constants/enums';

const defaultOptions = [
  {
    value: EditPosOrderType.void,
    label: 'Void',
    icon: <DoDisturbAltIcon />,
  },
  {
    value: EditPosOrderType.return,
    label: 'Return',
    icon: <UndoIcon />,
  },
  {
    value: EditPosOrderType.editPayment,
    label: 'Edit Payment',
    icon: <EditOutlinedIcon />,
  },
  {
    value: EditPosOrderType.mergeOrders,
    label: 'Merge Orders',
    icon: <MergeOutlinedIcon />,
  },
];

export const getEditOptions = () => defaultOptions;
